export default "__VITE_ASSET__Kr9UszlS__"